import React from 'react';
import { Route, Routes } from 'react-router-dom';
import Dashboard from 'components/pages/Dashboard';
import LayoutPage from 'components/layout/LayoutPage';
import AccountRoute from './AccountRoute';
import RouteChangeCanceler from './RouteChangeCanceler';
import KosoftDashboard from 'components/pages/KosoftDashboard';

const PrivateRoute: React.FC = () => {
    return (
        <div>
            <RouteChangeCanceler />
            <LayoutPage>
                <Routes>
                    <Route path="/dashboard" element={<Dashboard />} />
                    <Route path="/ko-dashboard" element={<KosoftDashboard />} />
                    <Route path='*' element={<AccountRoute/>}/>
                </Routes>
            </LayoutPage>
        </div>
    );
};

export default PrivateRoute;
